import React from 'react';
import withIcon from '../utilities/withIcon'; 

const IconDocumentUserFilled = () => {
  return (
    <g>
      <path
        d="m4.94.005 8.012.012c.54.001.985.41 1.042.936l.006.114V14.95c0 .541-.41.987-.936 1.044L12.95 16H1.05a1.05 1.05 0 0 1-1.044-.936L0 14.95V4.94L4.94.004zM6 1.505V4.95c0 .541-.41.987-.936 1.044L4.95 6H1.5v8.5l1.898-.001.037-.128C3.744 13.32 4.48 12 6.078 12h2.844c1.665 0 2.394 1.433 2.679 2.5h.899V1.514L6 1.505zM7.5 6.5c1.105 0 2 .824 2 1.84 0 1.018-.895 2.66-2 2.66s-2-1.642-2-2.66c0-1.016.895-1.84 2-1.84zm-3-3.937L2.561 4.5H4.5V2.562z"
        
      />
    </g>
  );
};

export default withIcon(IconDocumentUserFilled);
